import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQSectionProps {
  faqs: FAQItem[];
}

export default function FAQSection({ faqs }: FAQSectionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <div className="max-w-3xl mx-auto space-y-3">
      {faqs.map((faq, index) => (
        <div
          key={index}
          className="rounded-lg border border-background-200 bg-background-50 overflow-hidden"
        >
          <button
            onClick={() => setOpenIndex(openIndex === index ? null : index)}
            className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer whitespace-nowrap"
          >
            <h4 className="font-heading text-sm md:text-base font-semibold text-foreground-800 pr-4">
              <a href="#">{faq.question}</a>
            </h4>
            <i
              className={`ri-arrow-down-s-line text-lg text-foreground-500 transition-transform duration-300 shrink-0 ${
                openIndex === index ? 'rotate-180' : ''
              }`}
            ></i>
          </button>
          {openIndex === index && (
            <div className="px-5 pb-4">
              <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}